import { upload } from './upload';

export const root = {};
export const id = {
  upload,
};
